import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme) => ({
  icon: {
    transform: theme.dir === "rtl" ? "rotate(180deg)" : "unset"
  }
}));

export default useStyles;
//# sourceMappingURL=PaginationEdges.styles.js.map
